import { Sort } from "@angular/material/sort";
import { OrderAdDetail } from "@core/models/order-ad-detail.model";
import { Order } from "@core/models/order.model";
import { OrderEditRestriction } from "@order/models/order-edit-restriction";
import { OrderOwner } from "@order/models/order-owner";
import { NavigationState } from "@shared/models/navigation-state";

export class OrderLineNavigationState extends NavigationState {
	override readonly className = "OrderLineNavigationState";

	order?: Order;
	orderAdDetail?: OrderAdDetail;
	restriction?: OrderEditRestriction;
	orderOwner?: OrderOwner;

	// The flag is introduced to pevent this scenario:
	// 1. Order is changed and open in the Order page
	// 2. User clicks Add or Modify Order Line
	// 3. On the Order Line page, user clicks Cancel and gets back to the Order page
	// 4. The user navigates away from the Order page without a warning.
	// This flag tells the Order Component that the Order has been mofified in one of the previous 'sessions'.
	orderHasUnsavedChanges?: boolean = false;

	orderLinesTableSort: Sort | undefined;
}
